import { t } from "@redotech/redo-i18n";

export function manualLabelInstructionsDefault(): string[] {
  return [
    t(
      "The product your returning requires a manual label to be generated, our team has been notified.",
    ),
    t("Please look out for an email from us with instructions."),
  ];
}
